import { Selector } from 'controllers/tied'
import { LoginState } from './_data'

type BroadcastUser = Selector<LoginState, LoginState['user']>
export const broadcast_user: BroadcastUser = state => state?.user